module.exports = __webpack_public_path__ + "img/mrc_common.8198fb5c.png";